module.exports = __webpack_public_path__ + "e31c921df476a6c5670897bbb6d13617.pdf";